import React, { useEffect, useState } from "react";
import { IconButton, Grid, TableRow, Box, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomDialog from "../../../Common/CustomDialog";
import ButtonContained from "../../../Common/ButtonContained";
import { useDispatch } from "react-redux";
import ErrorHandler, { ReadMore } from "../../../../Utils/handler";
import { toast } from "react-toastify";
import { addFaqs, deleteFaqs, getFaqs, updateFaqs } from "../../../../Redux/Actions/action";
import TextLabel from "../../../Common/CommonTextLabel";
import CommonTable from "../../../Common/CommonTable";
import StyledTableCell from "../../../Common/styledTableCell";
import { showLoader } from "../../../../Redux/Slices/loaderSlice";
import CustomPagination from "../../../Common/CommonPagination";
import CommonTextField from "../../../Common/CommonTextField";
import DataNotFound from "../../../Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const headerList = ["No", "Question", "Answer", "Edit", "Delete"]

const Faq = () => {
    // ---------- Hook -----------
    const dispatch = useDispatch();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({})
    const [faqData, setFaqData] = useState({});
    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // --------------- handleChange ---------------
    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({})
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value.trimStart() });
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);

    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const validation = () => {
        let isValid = true;
        let error = {}
        if (!data.question) {
            error.question = "Question is required";
            isValid = false;
        }
        if (!data.answer) {
            error.answer = "Answer is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    }

    // --------------- Api ---------------
    const _createUpdateFaq = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            try {
                let body = {
                    question: data?.question,
                    answer: data?.answer
                }
                if (isEdit && data?._id) {
                    body._id = data?._id;
                }
                const fn = isEdit ? updateFaqs : addFaqs
                const result = await dispatch(fn(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getFaqs()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false))
            }
        }
    }

    const _getFaqs = async () => {
        dispatch(showLoader(true))
        let body = {
            page: page,
            limit: rowsPerPage
        }
        try {
            const result = await dispatch(getFaqs(body));
            const error = ErrorHandler(result);
            if (error) {
                // toast.success(result?.payload?.message);
                setFaqData(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _deleteFaqs = async (id) => {
        dispatch(showLoader(true))
        try {
            const result = await dispatch(deleteFaqs(`/${id}`));
            console.log(result, 'deletefaq')
            const error = ErrorHandler(result);
            if (error) {
                toast.success(result?.payload?.message);
                _getFaqs()
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    // ---------- useEffect ------------ 
    useEffect(() => {
        _getFaqs()
    }, [page, rowsPerPage])

    return (
        <Grid container spacing={1} xs={12}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>FAQ</Typography>
                    <ButtonContained text={'Add FAQ'} onClick={() => setOpen(true)} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <CommonTable
                    headerList={headerList}
                    minWidth={400}
                // sx={{ mt: 2 }}
                >
                    {faqData?.data?.length > 0 ? faqData?.data?.map((faq, index) => (
                        <TableRow key={faq.id}>
                            <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                            <StyledTableCell align="center"><ReadMore content={faq?.question} /></StyledTableCell>
                            <StyledTableCell align="center"><ReadMore content={faq?.answer} /> </StyledTableCell>
                            <StyledTableCell align="center">
                                <IconButton sx={{ padding: 0 }} onClick={() => {
                                    setOpen(true);
                                    setIsEdit(true);
                                    setData(faq)
                                }} >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <IconButton sx={{ padding: 0 }} onClick={() => {
                                    console.log(faq?._id, 'ifddddd')
                                    _deleteFaqs(faq?._id)
                                }} >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </StyledTableCell>
                        </TableRow>
                    )) :
                        (
                            <TableRow>
                                <StyledTableCell colSpan={8}>
                                    <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                </StyledTableCell>
                            </TableRow>
                        )
                    }
                </CommonTable>
                {faqData?.count > 0 &&
                    <Grid item xs={12}>
                        <CustomPagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={Math.ceil(faqData?.count / rowsPerPage)}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage} />

                    </Grid>
                }
                
                {open && <CustomDialog
                    isOpen={open} handleClose={handleClear} title={isEdit ? 'Update FAQ' : 'Add FAQ'} padding={'10px'}
                    width={400}
                    action={
                        <>
                            <ButtonContained
                                text={isEdit ? 'Update FAQ' : 'Add FAQ'}
                                onClick={() => {
                                    _createUpdateFaq()
                                    console.log('wwww')
                                }}
                                minWidth={'100%'}
                                marginTop={'10px'}

                            />
                        </>
                    }
                >
                    <Grid container spacing={2} xs={12}>
                        <Grid item xs={12}>
                            <CommonTextField
                                value={data?.question}
                                width={"100%"}
                                text="Question"
                                type="text"
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Enter a Question"
                                name="question"
                                valid
                            />
                            <TextLabel
                                title={!data?.question ? error?.question : ""}
                                color="error"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CommonTextField
                                value={data?.answer}
                                width={"100%"}
                                text="Answer"
                                type="text"
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Enter a Answer"
                                name="answer"
                                valid
                            />
                            <TextLabel
                                title={!data?.answer ? error?.answer : ""}
                                color="error"
                            />
                        </Grid>
                    </Grid>
                </CustomDialog>}
            </Grid>
        </Grid>
    );
};

export default Faq;
